/*
 * @Description: 
 */
/*
 * @Description: 
 */

let baseURL = process.env.VUE_APP_API


const API = {
    // 
    swiperData: '/carousel/getCarouselList',

    newsList:'/information/getInformationList',

    caseList:'/documentation/getDocumentationList',


    productList:'/product/getProductList',
    

    planList:'/scheme/getSchemeList',

    editProduct:'/product/saveOrUpdateProduct',



}

export default API
